module.exports = __webpack_public_path__ + "img/big_11B05_red.9cd38491.png";